import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationHE from './locales/he/translation.json';
import translationAR from './locales/ar/translation.json';

// Translation resources
const resources = {
  en: {
    translation: translationEN
  },
  he: {
    translation: translationHE
  },
  ar: {
    translation: translationAR
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'he', // Hebrew as default (current app language)
    supportedLngs: ['en', 'he', 'ar'],

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    // Load Hebrew first
    lng: 'he', // Force Hebrew as initial language

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: false // Disable suspense to avoid loading issues
    }
  });

// Update HTML attributes whenever language changes
i18n.on('languageChanged', (lng) => {
  const direction = lng === 'ar' || lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', direction);
  document.documentElement.setAttribute('lang', lng);
  document.body.setAttribute('dir', direction);
});

// Set initial direction and language
const initialLng = i18n.language || 'he';
const initialDir = initialLng === 'ar' || initialLng === 'he' ? 'rtl' : 'ltr';
document.documentElement.setAttribute('dir', initialDir);
document.documentElement.setAttribute('lang', initialLng);
document.body.setAttribute('dir', initialDir);

// Expose i18next instance to window for testing and debugging
if (typeof window !== 'undefined') {
  window.i18next = i18n;
}

export default i18n;
